module.exports = "pegasus_template/assets/theme4/main-bg.png";